import { render, staticRenderFns } from "./ScrollableMessageWrapper.vue?vue&type=template&id=6276ca5a&scoped=true&"
import script from "./ScrollableMessageWrapper.vue?vue&type=script&lang=js&"
export * from "./ScrollableMessageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableMessageWrapper.vue?vue&type=style&index=0&id=6276ca5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6276ca5a",
  null
  
)

export default component.exports